<template lang="pug">
.item.d-flex.flex-column.justify-content-center.align-items-center
  img.flex-shrink-0(:src="item.img")
  .content.i_mt_2
    h5.text-center {{ item.title }}
    p.i_body_l {{ item.content }}
</template>

<script>
export default {
  name: "Item",
  props: {
    item: Object,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/about_us/public_info/item";
</style>
